function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

function validateEmailInput() {
    const emailInput = document.getElementById('ContactForm-email');
    const email = emailInput.value.trim(); // Trim whitespace from the input

    const emailValidationMessage = document.getElementById('emailValidationMessage');
    const submitButton = document.querySelector('.contact__button button');

    if (email === '') {
        emailValidationMessage.textContent = 'Email address cannot be empty';
        emailValidationMessage.style.color = '#eb0045';
        submitButton.disabled = true;
    } else if (!validateEmail(email)) {
        emailValidationMessage.textContent = 'Invalid email address';
        emailValidationMessage.style.color = '#eb0045';
        submitButton.disabled = true;
    } else {
        emailValidationMessage.textContent = '';
        submitButton.disabled = false;
    }
}

function validatePhoneNumberFormat() {
    const input = document.getElementById('ContactForm-phone');
    const phoneNumber = input.value.trim();

    // Regular expression to match the format XXX-XXX-XXXX
    const re = /^\d{3}-\d{3}-\d{4}$/;

    const phoneNumberError = document.getElementById('phoneNumberError');
    const submitButton = document.querySelector('.contact__button button');

    if (phoneNumber === '') {
        // Handle case where input is empty
        phoneNumberError.textContent = 'Phone number cannot be empty';
        submitButton.disabled = true;
    } else if (!re.test(phoneNumber)) {
        // Handle case where input does not match the expected format
        phoneNumberError.textContent = 'Please enter a valid phone number format: XXX-XXX-XXXX';
        submitButton.disabled = true;
    } else {
        // Clear any previous error messages if format is correct
        phoneNumberError.textContent = '';
        submitButton.disabled = false;
    }
}

function formatPhoneNumber() {
    const input = document.getElementById('ContactForm-phone');
    let phoneNumber = input.value.replace(/\D/g, ''); // Remove all non-numeric characters

    // Format as XXX-XXX-XXXX
    let formattedPhoneNumber = '';
    for (let i = 0; i < phoneNumber.length && i < 10; i++) {
        if (i === 3 || i === 6) {
            formattedPhoneNumber += '-';
        }
        formattedPhoneNumber += phoneNumber.charAt(i);
    }

    input.value = formattedPhoneNumber;
}

class TabsSection extends HTMLElement {
  constructor() {
    super();
    this.tabs = null;
    this.contents = null;
    this.extraContents = null; // ✅ new
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.tabs = this.querySelectorAll(".tab-link");
      this.contents = this.querySelectorAll(".tab-content");
      this.extraContents = this.querySelectorAll(".tab-extra"); // ✅ new
      this.bindEvents();
    });
  }

  bindEvents() {
    if (!this.tabs.length || !this.contents.length) return;

    this.tabs.forEach(tab => {
      tab.addEventListener("click", () => this.activateTab(tab));
    });
  }

  activateTab(tab) {
    const target = tab.getAttribute("data-tab");

    // remove all actives
    this.tabs.forEach(t => t.classList.remove("active"));
    this.contents.forEach(c => c.classList.remove("active"));
    this.extraContents?.forEach(e => e.classList.remove("active")); // ✅ new

    // activate current
    tab.classList.add("active");

    const targetContent = this.querySelector(`#${target}`);
    if (targetContent) targetContent.classList.add("active");

    // ✅ Also activate the matching extra section (if exists)
    const targetExtra = this.querySelector(`#${target}-extra`);
    if (targetExtra) targetExtra.classList.add("active");
  }
}

if (!customElements.get("tabs-section")) {
  customElements.define("tabs-section", TabsSection);
}


document.addEventListener("DOMContentLoaded", function () {
  const stickyEl = document.querySelector(".sticky-add-to-cart");
  const targetEl = document.querySelector(".product-form__buttons .product-form__submit");

  if (stickyEl && targetEl) {
    let lastY = window.scrollY;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const currentY = window.scrollY;
          const scrollingDown = currentY > lastY;
          lastY = currentY;

          if (!entry.isIntersecting && scrollingDown) {
            stickyEl.classList.add("sticky-shown");
          } else if (entry.isIntersecting) {
            stickyEl.classList.remove("sticky-shown");
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(targetEl);
  }
});
